import { useLocale } from "../../hooks/useLocale";
import { msg } from "../../locales/translate";
import Button from "@ui/button/Button";
import { Page } from "@ui/page/Page";
import Spacer from "@ui/spacer/Spacer";
import { TabItem, Tabs } from "@ui/tabs/Tabs";
import { GD } from "../../GD";
import { Sessions } from "../forms/Sessions";
import { checkFeature } from "src/Featuresmap";
import { Clients } from "../conponents/list/Clients";
import { ClientGroups } from "../conponents/list/ClientGroups";
import { useRouter } from "src/services/Router";
import { S_REGISTER_PAYSWIX_CLIENT_POPUP } from "../popup/RegisterPayswixClientPopup";
import { CreditCard, Globe, Plus, Users } from "lucide-react";
import { useHasPermission } from "src/hooks/tools";

export const ClientsPage = () => {
	useLocale();
	const [project] = GD.REQ_CURRENT_PROJECT.useRequest();
	const router = useRouter();
	const showAdminControls = useHasPermission("clients.create");

	const label = project && project?.name + msg("clients_ee9b417d");

	const onAdd = async () => {
		if (project?.id === 3 || project?.id === 5) {
			// Payswix and payswix-sendbox share the client registration form.
			S_REGISTER_PAYSWIX_CLIENT_POPUP.invoke({ onSuccess: () => GD.S_CLIENTS_UPDATE.invoke({}) });
		} else {
			router.navigate("registerClient", { rid: "0" });
		}
	};

	return (
		<Page
			label={label ?? undefined}
			description={msg("clientPortfolioWebsitesMerchantsAndPaymentActivity")}
			icon={<Users size={20} />}
			// rightSection={<RightSectionClients sx={{ maxWidth: "350px" }} />}
			>
			<Tabs
				variant="modern"
				checkFeature={feature => checkFeature(feature as any)}
				decoration={showAdminControls
					? <Button onClick={onAdd} title={msg("addClient")} variant="primarySmall" icon={<Plus size={14} />} />
					: undefined}>
				<TabItem title={msg("clientsList")} icon={<Users size={16} />}>
					<Spacer size="20px" />
					<Clients />
				</TabItem>

				{/* <TabItem title="Clients flow">
					<Spacer size="20px" />
					<ClientsFlowPageCanva />
				</TabItem> */}

				<TabItem title={msg("websites")} icon={<Globe size={16} />}>
					<Spacer size="20px" />
					{/* <MerchantGroups internal={true} /> */}
					<ClientGroups hideControls variant="portfolio" />
					{/* <Clients hideControls /> */}
				</TabItem>

				<TabItem title={msg("payments")} icon={<CreditCard size={16} />}>
					<Spacer size="20px" />
					<Sessions target_id={0} target_type="project" filterAppearance="portfolio" />
				</TabItem>
			</Tabs>
		</Page>
	);
};

// const RightSectionClients = ({}: { sx?: RecursiveCSS }) => {
// 	return (
// 		<Box
// 			sx={{
// 				display: "flex",
// 				flex: 1,
// 				minHeight: "0px",
// 				flexDirection: "column",
// 				gap: "10px",
// 			}}>
// 			<Events targetId={1} targetType="client" />
// 			<Comments sectionType={0} targetId={1} targetType="client" />
// 		</Box>
// 	);
// };
